import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { functions } from '../../utils/firebase';
import { httpsCallable } from 'firebase/functions';

const AdminBootstrap: React.FC = () => {
  const { user, refreshAdminStatus } = useAuth();
  const [status, setStatus] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const handleBootstrap = async () => {
    if (!user?.email) {
      setStatus('Error: Not logged in');
      return;
    }

    setLoading(true);
    setStatus('Setting admin claim...');

    try {
      const setAdminClaim = httpsCallable(functions, 'setAdminClaim');
      const result = await setAdminClaim({ email: user.email, isAdmin: true });
      console.log('Result:', result);
      setStatus(`Success! ${(result.data as any).message}`);

      // Refresh the token to get the new claim
      await refreshAdminStatus();

      setStatus(prev => prev + '\n\nToken refreshed. Redirecting to admin...');

      // Redirect after a short delay
      setTimeout(() => {
        window.location.href = '/admin';
      }, 2000);
    } catch (error: any) {
      console.error('Bootstrap error:', error);
      setStatus(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Admin Bootstrap</h1>
          <p className="text-gray-500 mb-4">Please log in first</p>
          <a href="/auth" className="underline">Go to Login</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold mb-4">Admin Bootstrap</h1>
        <p className="text-gray-600 mb-4">Logged in as: <strong>{user.email}</strong></p>

        <button
          onClick={handleBootstrap}
          disabled={loading}
          className="w-full bg-black text-white py-3 px-4 rounded hover:bg-gray-800 disabled:opacity-50"
        >
          {loading ? 'Processing...' : 'Grant Admin Access'}
        </button>

        {status && (
          <pre className="mt-4 p-4 bg-gray-100 rounded text-sm whitespace-pre-wrap">
            {status}
          </pre>
        )}
      </div>
    </div>
  );
};

export default AdminBootstrap;
